var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99992 11C8.96695 11 8.93473 11.0098 8.90732 11.0281C8.87992 11.0464 8.85855 11.0724 8.84594 11.1029C8.83332 11.1333 8.83002 11.1669 8.83645 11.1992C8.84289 11.2315 8.85876 11.2612 8.88207 11.2845C8.90538 11.3078 8.93507 11.3237 8.9674 11.3301C8.99973 11.3366 9.03324 11.3333 9.0637 11.3206C9.09415 11.308 9.12018 11.2867 9.1385 11.2593C9.15681 11.2319 9.16659 11.1996 9.16659 11.1667C9.16659 11.1225 9.14903 11.0801 9.11777 11.0488C9.08651 11.0176 9.04412 11 8.99992 11Z",
    stroke: "#ff3b30",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.66667V6",
    stroke: "#ff3b30",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9C4 10.3261 4.52678 11.5979 5.46447 12.5355C6.40215 13.4732 7.67392 14 9 14C10.3261 14 11.5979 13.4732 12.5355 12.5355C13.4732 11.5979 14 10.3261 14 9C14 7.67392 13.4732 6.40215 12.5355 5.46447C11.5979 4.52678 10.3261 4 9 4C7.67392 4 6.40215 4.52678 5.46447 5.46447C4.52678 6.40215 4 7.67392 4 9V9Z",
    stroke: "#ff3b30",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSmall);
export default __webpack_public_path__ + "static/media/warning-small.e113ec09b4f746d2315219e4642ed06b.svg";
export { ForwardRef as ReactComponent };